<template>
  <div class="indented">
    <form @submit.prevent="submitForm" ref="formHTML">
      <h3>{{ catname }}</h3>
      <div class="form-horizontal">
        <h4>Add Product</h4>
        <hr />
        <div class="form-group spaced">
          Name:
          <div class="col-md-10">
            <input type="text" name="name" v-model="name" required class="form-control" />
          </div>
        </div>

        <div class="form-group spaced">
          Description:
          <div class="col-md-10">
            <input type="text" name="description" v-model="description" required class="form-control" />
          </div>
        </div>

        <div class="form-group spaced">
          Price:
          <div class="col-md-10">
            <input type="text" name="price" v-model="price" required class="form-control" />
          </div>
        </div>
        <div class="spacer"></div>
        <div class="form-group spaced">
          Picture:
          <div class="col-md-10">
            <input type="file" name="imgfile" required @change="onFileChange" />
            <img v-if="url" :src="url" width=200 />
          </div>
        </div>
        <div class="form-group spaced">
          After clicking Browse...and choosing image, check here if url of uploaded image has a value:
          <div class="smallspacer"></div>
          <div class="col-md-10">
            <div id="url"></div>
          </div>
          <div class="smallspacer"></div>
          If you see no url here, click Browse... button again and choose image!
        </div>
        <div class="form-group">
          <div class="col-md-10">
            <input type="submit" value="Create" v-if="formcomplete" class="button btn btn-default" />
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import axios from 'axios';
  import qs from 'qs'; // qs was installed from command prompt with npm install qs
  export default {
    name: 'Comp_AddProduct',
    props: ['catid','catname','level'],
    data() {
      return {
        errors: [],
        form: {},
        name: null,
        description: null,
        price: null,
        url: null,
        imageurl: null
      }
    },
    mounted() {
      this.imageurl = null;
    },
    computed: {
      formcomplete() {
        if (this.name && this.description && this.price && this.imageurl) {
          return true;
        }
        return false;
      }
    },
    methods: {
      submitForm() {
        const body = {
          "name": this.name,
          "description": this.description,
          "price": this.price,
          "picture": this.imageurl,
          "catid": this.catid
        }
        const url = 'https://api-japie.top/meubels/addproduct';
        let options = {
          method: "POST",
          headers: { "content-type": "application/x-www-form-urlencoded" },
          data: qs.stringify(body),
          url
        };
        axios(options)
          .then(res => {
            this.$emit('showprodofcat');
          })
      },
      onFileChange(e) {
        var cloudname = 'dz7ni7eqi';
        var uploadpreset = 'gwhxdpwq';

        const url = "https://api.cloudinary.com/v1_1/" + cloudname + "/image/upload";

        const file = e.target.files[0];
        this.url = URL.createObjectURL(file);

        var data = new FormData();
        data.append('upload_preset', uploadpreset);
        data.append('file', file);
        data.append('cloud_name', cloudname);
        
        fetch(url, {
          method: "POST",
          body: data
        })
          .then((response) => {
            return response.json();
          })
          .then((data) => {
            var http_string = data.url;
            let https_string = http_string.replace("http:", "https:");
            document.getElementById("url").innerHTML += https_string;
            this.imageurl = https_string;
          });

      }
    }
  }
</script>

<style scoped src="bootstrap/dist/css/bootstrap.min.css">
  /* install bootstrap first by typing 'npm install bootstrap' in command prompt */
</style>

<style scoped>

  .indented {
    margin: 20px;
    max-width: 550px;
  }

  .spacer {
    height:65px;
    border: 0px solid black;
  }

  .smallspacer {
    height: 20px;
    border: 0px solid black;
  }

  .text-danger {
      margin-top: 10px;
      color: red;
  }

  .spaced {
    margin-bottom: 10px;
  }

  .button {
    border: 1px solid gray;
  }
</style>




// WEBPACK FOOTER //
// src/Comp_AddProduct.vue